// @flow
import React from 'react';
import './AdminNavbar.css';

export type Props = {
  onLogoutClick: Function,
};

const AdminNavbar = ({onLogoutClick}: Props) => (
  <div className="AdminNavbar">
    <div className="row fill-height align-justify">
      <div className="align-self-middle shrink column">
        <div className="AdminNavbar-header">Hökerum Bygg</div>
      </div>
      <div className="align-self-middle shrink column">
        <button
          type="button"
          className="AdminNavbar-logout"
          onClick={() => onLogoutClick()}>
          Logga ut
        </button>
      </div>
    </div>
  </div>
);

export default AdminNavbar;



// WEBPACK FOOTER //
// ./src/components/AdminNavbar/AdminNavbar.js